// ----------------------------------------------------------------------

const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/dashboard',
};


// ----------------------------------------------------------------------

export const paths = {
  minimalUI: 'https://mui.com/store/items/minimal-dashboard/',
  // AUTH
  auth: {
    jwt: {
      login: `${ROOTS.AUTH}/jwt/login`,
      register: `${ROOTS.AUTH}/jwt/register`,
      forgotPassword: `${ROOTS.AUTH}/jwt/forgotPassword`,
    },
  },
  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
    user: {
      new: `${ROOTS.DASHBOARD}/usuarios/new`,
      list: `${ROOTS.DASHBOARD}/usuarios`,
    },
    roles: {
      new: `${ROOTS.DASHBOARD}/roles/new`,
      list: `${ROOTS.DASHBOARD}/roles`,
    },
    companies: {
      new: `${ROOTS.DASHBOARD}/Empresas/new`,
      list: `${ROOTS.DASHBOARD}/Empresas`,
    },
    products: {
      new: `${ROOTS.DASHBOARD}/productos/new`,
      list: `${ROOTS.DASHBOARD}/productos`,
    },
    settingFel: {
      new: `${ROOTS.DASHBOARD}/configuracionFel/new`,
      list: `${ROOTS.DASHBOARD}/configuracionFel`,
    },
    relationRolService: {
      list: `${ROOTS.DASHBOARD}/ServicioRol`,
    },
    clients: {
      list: `${ROOTS.DASHBOARD}/clientes`,
    },
    transactionsClients: {
      list: `${ROOTS.DASHBOARD}/transacciones`,
    },
    history: {
      list: `${ROOTS.DASHBOARD}/historico`,
    },
    organization: {
      list: `${ROOTS.DASHBOARD}/organizaciones`,
      new: `${ROOTS.DASHBOARD}/organizaciones/new`
    },
    onboarding: {
      list: `${ROOTS.DASHBOARD}/Onboarding`,
      new: `${ROOTS.DASHBOARD}/Onboarding/new`,
      edit: (uuid) => `${ROOTS.DASHBOARD}/Onboarding/${uuid}/edit`,
      ver: (uuid) => `${ROOTS.DASHBOARD}/Onboarding/${uuid}/ver`,
      detail: (uuid) => `${ROOTS.DASHBOARD}/Onboarding/${uuid}`,
    }
  },
};
